import { render, staticRenderFns } from "./newOaWorkflowForm.vue?vue&type=template&id=c8e80d6e&scoped=true"
import script from "./newOaWorkflowForm.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowForm.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowForm.vue?vue&type=style&index=0&id=c8e80d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e80d6e",
  null
  
)

export default component.exports